import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fullscreen",
  "use": "fullscreen-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fullscreen\"><title>Fullscreen</title><g fill-rule=\"evenodd\"><path d=\"M.611 5.303a.611.611 0 0 0 .611-.61V2.086l3.936 3.935a.61.61 0 0 0 .864 0 .611.611 0 0 0 0-.865L2.086 1.222h2.606a.611.611 0 0 0 0-1.222H.612A.611.611 0 0 0 0 .611v4.081c0 .338.274.611.611.611M16.936 12.243a.611.611 0 0 0-.611.612v2.605l-4.057-4.057a.611.611 0 1 0-.865.864l4.058 4.057h-2.606a.611.611 0 1 0 0 1.223h4.081a.611.611 0 0 0 .611-.612v-4.08a.611.611 0 0 0-.611-.612M5.28 11.403L1.222 15.46v-2.606a.611.611 0 0 0-1.223 0v4.082c0 .337.274.61.612.61h4.08a.611.611 0 1 0 0-1.222H2.087l4.057-4.057a.611.611 0 1 0-.865-.864M16.936 0h-4.081a.611.611 0 1 0 0 1.222h2.606l-3.936 3.936a.61.61 0 1 0 .864.864l3.936-3.936v2.606a.611.611 0 1 0 1.222 0V.612A.611.611 0 0 0 16.936 0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/fullscreen.svg
// module id = 14
// module chunks = 0